import { render, staticRenderFns } from "./CoursePlanning.vue?vue&type=template&id=9ad33b68&scoped=true&"
import script from "./CoursePlanning.vue?vue&type=script&lang=js&"
export * from "./CoursePlanning.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlanning.vue?vue&type=style&index=0&id=9ad33b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad33b68",
  null
  
)

export default component.exports